import React, { useEffect, useCallback } from 'react';
import App from '../App/App';
import ScreenLoader from '../../components/ScreenLoader';
import AssetBlocked from "../../components/AssetBlocked";
import * as actions from "../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import queryString from 'query-string';
import { setViewerThunk } from '../../redux/thunks/setViewerThunk';
import { assetStatusThunk } from '../../redux/thunks/setDataThunk';

const Wrapper = (props) => {
  const dispatch = useDispatch();

  const { shadeState } = useSelector(state => ({
    shadeState: state.shadeState,
  }));

  const handleViewerSettings = useCallback(async () => {
    const params = queryString.parse(props.location.search);

    if(shadeState === "SHADE_START") {
      if(params.variant) await dispatch(setViewerThunk({ variant: params.variant }));
      dispatch(actions.setShadeReady("SHADE_LOADING"));
    } else if(shadeState === "SHADE_LOADING") {
      const status = await dispatch(assetStatusThunk(params));

      if(!status) {
        dispatch(actions.setShadeReady("SHADE_BLOCKED"));
        return
      }
      setTimeout(() => {
        dispatch(actions.setShadeReady("SHADE_VIEWER"));
      }, 1500)
    }
  }, [shadeState, props.location, dispatch]);

  useEffect(() => {
    handleViewerSettings();
  }, [handleViewerSettings]);

  return (
    <div className="Wrapper">
      { shadeState === "SHADE_LOADING" && <ScreenLoader location={props.location} /> }
      { (shadeState === "SHADE_VIEWER" || shadeState === "SHADE_READY") && <App /> }
      { shadeState === "SHADE_BLOCKED" &&  <AssetBlocked /> }
    </div>
  );
};

export default withRouter(Wrapper);
